module.exports = __webpack_public_path__ + "static/media/rlogo.2b03bcc4.png";